module.exports = __webpack_public_path__ + "static/media/20_avatar.c598be2d.png";